export class ConfiguracionDiseno {
    idConfiguracionTextosColores?: number;
    tituloResumenContable?: string;
    tituloUltimasCompras?: string;
    tituloMisCompras?: string;
    tituloComprasFacturadas?: string;
    tituloPendientesFacturar?: string;
    tituloProductos?: string;
    tituloGuiasPendientes?: string;
    imagenUltimasCompras?: string;
    bannerPortal?: string;
    imagenUsuario?: string;
    iconoContactos?: string;
    bannerMisCompras?: string;
    iconoMisCompras?: string;
    colorTextoUltimasCompras?: string;
    colorBotonUltimasCompras?: string;
    colorHoverBotonUltimasCompras?: string;
    colorIconoPendientes?: string;
    colorTextoPendientes?: string;
    colorIconoVencidos?: string;
    colorTextoVencidos?: string;
    colorIconoPorVencer?: string;
    colorTextoPorVencer?: string;
    colorSeleccionDocumentos?: string;
    iconoClavePerfil?: string;
    iconoEditarPerfil?: string;
    iconoEstadoPerfil?: string;
    colorBotonModificarPerfil?: string;
    colorBotonClavePerfil?: string;
    colorBotonEstadoPerfil?: string;
    colorHoverBotonesPerfil?: string;
    colorBotonCancelarModalPerfil?: string;
    colorBotonGuardarModalPerfil?: string;
    colorFondoMisCompras?: string;
    colorIconosMisCompras?: string;
    colorTextoMisCompras?: string;
    colorBotonBuscar?: string;
    colorPaginador?: string;
    colorTextoFechaUltimasCompras?: string;
    colorTextoMontoUltimasCompras?: string;
    colorTextoBotonUltimasCompras?: string;
    colorFondoDocumentos?: string;
    colorFondoUltimasCompras?: string;
    colorFondoResumenContable?: string;
    colorFondoVencidos?: string;
    colorFondoPorVencer?: string;
    tituloPendientesDashboard?: string;
    tituloVencidosDashboard?: string;
    tituloPorVencerDashboard?: string;
    tituloMonedaPeso?: string;
    tituloOtraMoneda?: string;
    colorFondoPendientesMisCompras?: string;
    colorFondoProductosMisCompras?: string;
    colorFondoGuiasMisCompras?: string;
    textoNoConsideraTodaDeuda?: string;
    imagenPortada?: string;
    colorFondoPortada?: string;
    logoPortada?: string;
    colorBotonInicioSesion?: string;
    colorBotonPagoRapido?: string;
    colorBotonPagar?: string;
    bannerPagoRapido?: string;
    logoMinimalistaSidebar?: string;
    logoSidebar?: string;
    favicon?: string;
    textoCobranzaExpirada?: string;
    textoDescargaCobranza?: string;


    constructor() {
        this.idConfiguracionTextosColores = 0;
        this.tituloResumenContable = '';
        this.tituloUltimasCompras = '';
        this.tituloMisCompras = '';
        this.tituloComprasFacturadas = '';
        this.tituloPendientesFacturar = '';
        this.tituloProductos = '';
        this.tituloGuiasPendientes = '';
        this.imagenUltimasCompras = '';
        this.bannerPortal = '';
        this.imagenUsuario = '';
        this.iconoContactos = '';
        this.bannerMisCompras = '';
        this.iconoMisCompras = '';
        this.colorTextoUltimasCompras = '';
        this.colorBotonUltimasCompras = '';
        this.colorHoverBotonUltimasCompras = '';
        this.colorIconoPendientes = '';
        this.colorTextoPendientes = '';
        this.colorIconoVencidos = '';
        this.colorTextoVencidos = '';
        this.colorIconoPorVencer = '';
        this.colorTextoPorVencer = '';
        this.colorSeleccionDocumentos = '';
        this.iconoClavePerfil = '';
        this.iconoEditarPerfil = '';
        this.iconoEstadoPerfil = '';
        this.colorBotonModificarPerfil = '';
        this.colorBotonClavePerfil = '';
        this.colorBotonEstadoPerfil = '';
        this.colorHoverBotonesPerfil = '';
        this.colorBotonCancelarModalPerfil = '';
        this.colorBotonGuardarModalPerfil = '';
        this.colorFondoMisCompras = '';
        this.colorIconosMisCompras = '';
        this.colorTextoMisCompras = '';
        this.colorBotonBuscar = '';
        this.colorPaginador = '';
        this.colorTextoFechaUltimasCompras = '';
        this.colorTextoMontoUltimasCompras = '';
        this.colorTextoBotonUltimasCompras = '';
        this.colorFondoDocumentos = '';
        this.colorFondoUltimasCompras = '';
        this.colorFondoResumenContable = '';
        this.colorFondoVencidos = '';
        this.colorFondoPorVencer = '';
        this.tituloPendientesDashboard = '';
        this.tituloPorVencerDashboard = '';
        this.tituloVencidosDashboard = '';
        this.tituloMonedaPeso = '';
        this.tituloOtraMoneda = '';
        this.colorFondoPendientesMisCompras = '';
        this.colorFondoProductosMisCompras = '';
        this.colorFondoGuiasMisCompras = '';
        this.textoNoConsideraTodaDeuda = '';
        this.imagenPortada = '';
        this.colorFondoPortada = '';
        this.logoPortada = '';
        this.colorBotonInicioSesion = '';
        this.colorBotonPagoRapido = '';
        this.colorBotonPagar = '';
        this.bannerPagoRapido = '';
        this.logoMinimalistaSidebar = '';
        this.logoSidebar = '';
        this.favicon = '';
        this.textoCobranzaExpirada = '';
        this.textoDescargaCobranza = '';
    }

}